import React from 'react'
import moment from 'moment'

const DateConversational = ({
    date,
    dayName,
    style = {},
    full,
    className = ''
}) => {
    const momentDate = moment(date)
    let label = `${momentDate.format('MMM')} ${momentDate.format('D')}`
    if (dayName) {
        label = `${momentDate.format('ddd')}, ${label}`
    }
    if (full) {
        label = `${momentDate.format('ddd')}, ${momentDate.format('MMM')} ${momentDate.format('Do')} ${momentDate.format('YYYY')}`
    }
    return (
        <span style={style} className={className}>
            {label}
        </span>
    )
}

export default DateConversational